import { BlockList } from '@zillow/cms-blocks';
import { Box } from '@zillow/constellation';
import React from 'react';

import { Block } from '../../types/blocks';

interface FooterTemplateProps {
    footer?: {
        blocks?: Block[];
    };
    relatedArticles?: React.ReactNode;
}

const FooterTemplate = ({
    footer,
    relatedArticles,
}: FooterTemplateProps): React.ReactNode => (
    <Box
        sx={{
            margin: '0 auto',
            maxWidth: '$breakpoints.xxl',
        }}
    >
        <Box
            sx={{
                padding: '0 $spacing.sm $spacing.xl',
                '@media $sm_lte': {
                    padding: '0 0 $spacing.xl',
                },
            }}
        >
            {relatedArticles}

            <BlockList blocks={footer?.blocks || []} />
        </Box>
    </Box>
);

export default FooterTemplate;
